import { createActionCreator } from '../../../lib/Actions';

// eslint-disable-next-line
export const createActions = key => {
  const createAction = createActionCreator(key);
  return {
    TOGGLE_EDITABLE: createAction('TOGGLE_EDITABLE'),
  };
};
